// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__oPWfV","text":"Breadcrumbs_text__3_LUF","text_active":"Breadcrumbs_text_active__tYwX6","separator":"Breadcrumbs_separator__uLJZP"};